import { useAuth0 } from "@auth0/auth0-react";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import useAPI from "../../api/hooks/useAPI";
import useColors from "../../api/hooks/useColors";
import UserMenu from "./UserMenu";

export const SidebarMenuAccountItem = ({ title, path, icon, collapsed }) => {
  const colors = useColors();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { trackEvent } = useAPI();
  const userProfileRef = useRef(null);

  /* set active item according to router */
  let active = false;
  let onboarding = false;

  const location = useLocation();
  if (path === "/") {
    if (path === "/" && location.pathname === path) active = true;
  } else active = location.pathname.includes(path);

  if (location.pathname.includes("onboarding")) {
    onboarding = true;
  }

  const { user, isAuthenticated } = useAuth0();

  const handleCloseSettingsMenu = () => {
    trackEvent("User closed settings menu");
    setAnchorElUser(null);
  };

  const handleOpenSettingsMenu = (event) => {
    trackEvent("User opened settings menu");
    setAnchorElUser(event.currentTarget);
  };

  // Effect to programmatically open the menu when openMenu prop changes
  useEffect(() => {
    if (onboarding && active) {
      setAnchorElUser(userProfileRef.current);
    }
  }, [location, onboarding, active, userProfileRef]);

  // Account for the User menu
  return (
    <Box
      sx={{
        zIndex: active && onboarding ? 1000 : 0,
        border:
          active && onboarding ? "1px solid " + colors.primary_200 : "none",
        boxShadow:
          active && onboarding ? "0 0 18px -3px " + colors.primary_200 : "none",
        color: active ? colors.primary_main : colors.contrast_text_dark,
        backgroundColor: active
          ? collapsed
            ? "transparent"
            : colors.sidebar_selected_tab
          : "transparent",
        width: active && onboarding ? "50px" : "35px",
        display: "flex",
        alignItems: "center",
        minHeight: "50px",
        padding: active && onboarding ? "8px" : "0px",
        borderRadius: "8px",

        cursor: "pointer",
        "&:hover": {
          backgroundColor: colors.grey_200,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Box
          ref={userProfileRef}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
          onClick={handleOpenSettingsMenu}
        >
          {isAuthenticated && (
            <img
              alt="profile-user"
              width="32px"
              height="32x"
              src={user.picture}
              style={{ cursor: "pointer", borderRadius: "50%" }}
            />
          )}
          {!isAuthenticated && (
            <PersonOutlinedIcon style={{ color: colors.common_white }} />
          )}
        </Box>
        {!collapsed && (
          <Typography variant="body2" onClick={handleOpenSettingsMenu}>
            {title}
          </Typography>
        )}
      </Box>
      <UserMenu
        anchorElUser={anchorElUser}
        handleCloseSettingsMenu={handleCloseSettingsMenu}
      ></UserMenu>
    </Box>
  );
};
